import { BrowserRouter, Navigate, Outlet, Route, Routes } from 'react-router-dom';
import { AppLayout } from './components/AppLayout';
import { canAdminister, canWrite } from './domain/roles';
import { OfflinePage } from './desktop/OfflinePage';
import { AdminEmployeesPage } from './pages/AdminEmployeesPage';
import { AdminUsersPage } from './pages/AdminUsersPage';
import { DiagnosticsPage } from './pages/DiagnosticsPage';
import { ImportPage } from './pages/ImportPage';
import { InventoryPage } from './pages/InventoryPage';
import { LoginPage } from './pages/LoginPage';
import { NotFoundPage } from './pages/NotFoundPage';
import { ReportViewerPage } from './pages/ReportViewerPage';
import { WorkstationPage } from './pages/WorkstationPage';
import { WorkstationsPage } from './pages/WorkstationsPage';
import { RealtimeProvider } from './realtime/RealtimeContext';
import { RequireRole, RequireSession } from './session/Guards';
import { SessionProvider } from './session/SessionContext';

export function App() {
  return (
    <BrowserRouter>
      <SessionProvider>
        <Routes>
          {/* seule route accessible sans session */}
          <Route path="/connexion" element={<LoginPage />} />

          {/*
            Le canal en direct n'est ouvert que sous session : le placer sous
            la garde évite une connexion refusée à chaque chargement de la
            page de connexion, et la boucle de reprise qui s'ensuivrait.
          */}
          <Route
            element={
              <RequireSession>
                <RealtimeProvider>
                  <Outlet />
                </RealtimeProvider>
              </RequireSession>
            }
          >
            <Route element={<AppLayout />}>
              <Route index element={<Navigate to="/postes" replace />} />
              <Route path="postes" element={<WorkstationsPage />} />
              <Route path="postes/:id" element={<WorkstationPage />} />
              <Route path="diagnostics" element={<DiagnosticsPage />} />
              <Route path="inventaire" element={<InventoryPage />} />
              <Route path="diagnostics/:id" element={<ReportViewerPage />} />
              {/*
                Déclarée dans les deux cas : la route n'a de contenu que dans
                l'application de bureau, et l'écran le dit lui-même si on
                l'atteint depuis un navigateur. Une route conditionnelle
                donnerait deux arbres de routage à tenir plutôt qu'un.
              */}
              <Route path="hors-ligne" element={<OfflinePage />} />
              {/*
                L'import est sous le poste, et non à la racine : il suppose un
                poste choisi, et le mettre dans le chemin supprime le cas
                « aucun poste » au lieu d'avoir à le traiter.
              */}
              <Route
                path="postes/:id/import"
                element={
                  <RequireRole role="technicien" allowed={canWrite}>
                    <ImportPage />
                  </RequireRole>
                }
              />
              <Route
                path="administration/utilisateurs"
                element={
                  <RequireRole role="administration" allowed={canAdminister}>
                    <AdminUsersPage />
                  </RequireRole>
                }
              />
              <Route
                path="administration/salaries"
                element={
                  <RequireRole role="administration" allowed={canAdminister}>
                    <AdminEmployeesPage />
                  </RequireRole>
                }
              />
              <Route path="*" element={<NotFoundPage />} />
            </Route>
          </Route>
        </Routes>
      </SessionProvider>
    </BrowserRouter>
  );
}
